import { useMemo } from 'react'

import { CurrencyType } from '@model/WalletDto'

import type { DxtradeInstrumentMap } from '../hooks/useDxtradeInstruments'
import type { PortfolioTrade } from '../hooks/useDxtradePortfolioTrades'
import { CardTradingView } from './CardTradingView'

export interface CardTradingProps {
  trades: PortfolioTrade[]
  isLoading: boolean
  accountCurrency?: CurrencyType
  accountCode?: string
  dxtradeInstruments?: DxtradeInstrumentMap
  hasActiveFilters?: boolean
}

export type CardTradingGroup = {
  symbol: string
  trades: PortfolioTrade[]
  totalPnl?: number
  sizeLots?: number
  totalMargin?: number
}

const groupTrades = (trades: PortfolioTrade[]): CardTradingGroup[] => {
  const map = new Map<string, PortfolioTrade[]>()
  for (const trade of trades) {
    const key = trade.symbol || '-'
    if (!map.has(key)) map.set(key, [])
    map.get(key)!.push(trade)
  }
  return Array.from(map.entries()).map(([symbol, list]) => ({
    symbol,
    trades: list,
    sizeLots: list.reduce((acc, t) => acc + (t.sizeLots ?? 0), 0),
    totalMargin: list.reduce((acc, t) => acc + (t.margin ?? 0), 0),
  }))
}

export const CardTrading: React.FC<CardTradingProps> = ({
  trades,
  isLoading,
  accountCurrency,
  accountCode,
  dxtradeInstruments,
  hasActiveFilters,
}) => {
  const groups = useMemo(() => groupTrades(trades), [trades])
  return (
    <CardTradingView
      groups={groups}
      isLoading={isLoading}
      accountCurrency={accountCurrency}
      accountCode={accountCode}
      dxtradeInstruments={dxtradeInstruments}
      hasActiveFilters={hasActiveFilters}
    />
  )
}

export default CardTrading
